(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-contact"] && !window.DesignMode) return;
  try {
    

  $('.contact-button').prop("disabled", false);
$('input:checkbox.checks').click(function() {
 if ($(this).is(':checked')) {
    $('.contact-button').prop("disabled", true);
 } else {
  if ($('.checks').filter(':checked').length < 1){
 $('.contact-button').attr('disabled',false);}
 }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-component-collection-categories"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function checkScrollPosition(initLoad = false) {
      $('.collection-menu').each(function () {
        var $this = $(this);
        var closeToEndX = false;
        var closeToEndY = false;

        // Check for horizontal scrolling
        if ($this[0].scrollWidth > $this.outerWidth()) {
          var scrollLeft = $this.scrollLeft();
          var maxScrollX = $this[0].scrollWidth - $this.outerWidth();
          closeToEndX = maxScrollX - scrollLeft <= 32;
        } else {
          closeToEndX = true; // No horizontal scroll
        }

        // Check for vertical scrolling
        if ($this[0].scrollHeight > $this.outerHeight()) {
          var scrollTop = $this.scrollTop();
          var maxScrollY = $this[0].scrollHeight - $this.outerHeight();
          closeToEndY = maxScrollY - scrollTop <= 32;
        } else {
          closeToEndY = true; // No vertical scroll
        }

        // Hide ::after if close to the end of either overflow, or no scroll at all
        if (closeToEndX && closeToEndY) {
          $this.addClass('hide-after');
          if (initLoad) {
            $this.addClass('remove-after');
          }
        } else {
          $this.removeClass('hide-after');
          $this.removeClass('remove-after');
        }
      });
    }

    // Initial check and setup event handlers for scroll
    checkScrollPosition(true);
    $('.collection-menu').scroll(function () {
      checkScrollPosition();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-component-collection-shop-all"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initializeSlick() {
      if (window.innerWidth >= 992) {
        // Ensure slick is only initialized above 991px
        $('.js-slider-collection').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          centerMode: false,
          focusOnSelect: false,
          infinite: true,
          variableWidth: false,
          arrows: true,
          nextArrow:
            '<a role="button" href="#" aria-label="Next Slide" class="next-arrow"><span class="hand-right-img"></span></a>',
          responsive: [
            {
              breakpoint: 992,
              settings: 'unslick',
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        });
      }
    }

    if (window.innerWidth > 991) {
      initializeSlick();
    }
    var previousWidth = $(window).width();
    $(window).resize(function () {
      var currentWidth = $(window).width();
      if ((previousWidth < 992 && currentWidth >= 992) || (previousWidth >= 992 && currentWidth < 992)) {
        initializeSlick(); // Reinitialize if necessary
      }
      previousWidth = currentWidth;
    });

    const sections = document.querySelectorAll('.collection-shop-all-category');
    const sectionLinks = document.querySelectorAll('.collection-category-link');

    sectionLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        if (window.innerWidth <= 991) {
          event.preventDefault();
          const targetId = this.getAttribute('href').replace('#', '');
          setActiveSection(targetId);
        }
      });
    });

    function setActiveSection(currentId) {
      sections.forEach((section) => {
        if (section.getAttribute('id') === currentId) {
          section.setAttribute('data-active', 'true');
        } else {
          section.setAttribute('data-active', 'false');
        }
      });
    }

    function handleScroll() {
      let current = '';
      let closestSectionDistance = Infinity;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const distance = Math.abs(window.pageYOffset - (sectionTop + sectionHeight / 2));

        if (distance < closestSectionDistance) {
          closestSectionDistance = distance;
          current = section.getAttribute('id');
        }
      });

      setActiveSection(current);
    }

    let debounceTimer;
    window.onscroll = () => {
      if (window.innerWidth > 991) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(handleScroll, 100);
      }
    };

    // MutationObserver to update link active state based on data-active attribute
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-active' &&
          mutation.target.getAttribute('data-active') === 'true'
        ) {
          const sectionId = mutation.target.getAttribute('id');
          sectionLinks.forEach((link) => {
            const isActive = link.getAttribute('href').includes(sectionId);
            link.classList.toggle('active', isActive);
          });
        }
      });
    });

    sections.forEach((section) => {
      observer.observe(section, { attributes: true });
    });

    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    function handleAnchorClick(event) {
      event.preventDefault();
      const targetId = event.currentTarget.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const yOffset = window.innerWidth <= 991 ? 0 : 150;
        window.scrollTo({
          top: targetElement.offsetTop + yOffset,
          behavior: 'instant',
        });
      }
    }

    anchorLinks.forEach((link) => link.addEventListener('click', handleAnchorClick));

    function checkScrollPosition() {
      $('.collection-menu').each(function () {
        var $this = $(this);
        var closeToEndX = false;
        var closeToEndY = false;

        // Check for horizontal scrolling
        if ($this[0].scrollWidth > $this.outerWidth()) {
          var scrollLeft = $this.scrollLeft();
          var maxScrollX = $this[0].scrollWidth - $this.outerWidth();
          closeToEndX = maxScrollX - scrollLeft <= 32;
        } else {
          closeToEndX = true; // No horizontal scroll
        }

        // Check for vertical scrolling
        if ($this[0].scrollHeight > $this.outerHeight()) {
          var scrollTop = $this.scrollTop();
          var maxScrollY = $this[0].scrollHeight - $this.outerHeight();
          closeToEndY = maxScrollY - scrollTop <= 32;
        } else {
          closeToEndY = true; // No vertical scroll
        }

        // Hide ::after if close to the end of either overflow, or no scroll at all
        if (closeToEndX && closeToEndY) {
          $this.addClass('hide-after');
        } else {
          $this.removeClass('hide-after');
        }
      });
    }

    // Initial check and setup event handlers for scroll
    checkScrollPosition();
    $('.collection-menu').scroll(checkScrollPosition);

    const collectionTitles = Array.from(document.querySelectorAll('.collection-category-link-title')).map((el) =>
      el.textContent.trim()
    );
    const prevSpans = document.querySelectorAll('.collection-footer-nav-prev-span');
    const nextSpans = document.querySelectorAll('.collection-footer-nav-next-span');

    collectionTitles.forEach((title, index) => {
      // Set the previous span text
      if (index === 0) {
        // First item, set to last title
        prevSpans[index].textContent = collectionTitles[collectionTitles.length - 1];
      } else {
        // Otherwise, set to the previous title
        prevSpans[index].textContent = collectionTitles[index - 1];
      }

      // Set the next span text
      if (index === collectionTitles.length - 1) {
        // Last item, set to first title
        nextSpans[index].textContent = collectionTitles[0];
      } else {
        // Otherwise, set to the next title
        nextSpans[index].textContent = collectionTitles[index + 1];
      }
    });

    window.cycleCollection = function (direction) {
      const currentActiveLink = document.querySelector('.collection-category-link.active');
      const allLinks = Array.from(document.querySelectorAll('.collection-category-link'));
      let currentIndex = allLinks.indexOf(currentActiveLink);
      let targetIndex;

      if (direction === 'prev') {
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) {
          // If it's the first item, cycle back to the last
          targetIndex = allLinks.length - 1;
        }
      } else if (direction === 'next') {
        targetIndex = currentIndex + 1;
        if (targetIndex >= allLinks.length) {
          // If it's the last item, cycle back to the first
          targetIndex = 0;
        }
      }

      // Simulate a click on the target link
      allLinks[targetIndex].click();
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-component-faq"] && !window.DesignMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).parent().toggleClass("expanded");   
      // refresh any scrolltriggers on the page:
        ScrollTrigger.refresh();
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(document).ready(function () {
      $('.js_mobile-footer-accordion-heading .control').click(function () {
          $(this).closest('.js_mobile-footer-accordion-heading').next().slideToggle(200);
          $(this).toggleClass("expanded");       
      });
      $('.js_mobile-footer-accordion-body').slideUp(200);
  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
  $(document).ready(function () {
      $('.js_mobile-nav-accordion-heading .control').click(function () {
          $(this).closest('.js_mobile-nav-accordion-heading').next().slideToggle(200);
          $(this).toggleClass("expanded");       
      });
      $('.js_mobile-nav-accordion-body').slideUp(200);
  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();
})();
